import { DataView } from '@vtex/admin-ui';
import { Header } from 'lib/components';
import { memo } from 'react';
import { ProductsTable, SelectedProductsTable } from './components';
import { useHighlightProductTable } from './hooks';
import { HighlightProductProps } from './types';
import { useTranslation } from 'react-i18next';

export const HighlightProductSection = memo((props: HighlightProductProps) => {
  const {
    collectionId,
    collectionName,
    columns,
    itemsPerPage,
    numberOfItems,
    pagination,
    selectedProductTableData,
    tableData,
    view,
    getBodyCell,
    getHeadCell,
    getTable,
    handlePageChange,
    handleSearch,
    updateItemsPerPage,
  } = useHighlightProductTable(props);

  const { t } = useTranslation();

  if (!collectionId)
    return <h5 className="mt-4">{t('adminHighlightProduct.noCollection')}</h5>;

  return (
    <DataView state={view}>
      <Header
        collectionId={collectionId}
        collectionName={collectionName}
        onSearch={handleSearch}
      />

      {!!selectedProductTableData.length && (
        <SelectedProductsTable
          columns={columns}
          selectedProduct={selectedProductTableData}
          getBodyCell={getBodyCell}
          getTable={getTable}
        />
      )}

      <ProductsTable
        columns={columns}
        initialSelectedOption={pagination.INITIAL_OPTION}
        itemsPerPage={itemsPerPage}
        numberOfItems={numberOfItems}
        options={pagination.OPTIONS}
        products={tableData}
        getBodyCell={getBodyCell}
        getHeadCell={getHeadCell}
        getTable={getTable}
        onChange={selectedOption => updateItemsPerPage(selectedOption)}
        onPageChange={handlePageChange}
      />
    </DataView>
  );
});
